/** پالت پیشنهادی رنگ موضوعات؛ رنگ‌ها با متن سفید و تیره هر دو خوانا هستند */
export const SUBJECT_COLOR_PRESETS = [
  '#0d9488', // teal
  '#2563eb', // blue
  '#7c3aed', // violet
  '#db2777', // pink
  '#e11d48', // rose
  '#ea580c', // orange
  '#d97706', // amber
  '#65a30d', // lime
  '#059669', // emerald
  '#0891b2', // cyan
  '#4f46e5', // indigo
  '#475569', // slate
];

export const DEFAULT_SUBJECT_COLOR = SUBJECT_COLOR_PRESETS[0];

const HEX_PATTERN = /^#[0-9a-f]{6}$/i;

export const normalizeHex = (color) => (HEX_PATTERN.test(color || '') ? color.toLowerCase() : DEFAULT_SUBJECT_COLOR);

/** روشنایی نسبی (WCAG) برای انتخاب رنگ متن خوانا روی پس‌زمینه */
const luminance = (hex) => {
  const [r, g, b] = [1, 3, 5].map((i) => {
    const c = parseInt(hex.slice(i, i + 2), 16) / 255;
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};

/**
 * استایل چیپ موضوع: پس‌زمینه کم‌رنگ از همان رنگ، حاشیه ملایم و متن با کنتراست کافی.
 * برای رنگ‌های خیلی روشن، متن تیره نمایش داده می‌شود.
 */
export const subjectChipStyle = (color, { solid = false } = {}) => {
  const hex = normalizeHex(color);
  const light = luminance(hex) > 0.45;

  if (solid) {
    return { backgroundColor: hex, borderColor: hex, color: light ? '#111827' : '#ffffff' };
  }

  return {
    backgroundColor: `${hex}1a`,
    borderColor: `${hex}59`,
    color: light ? '#374151' : hex,
  };
};

/** رنگ پیشنهادی برای موضوع بعدی (اولین رنگ پالت که هنوز استفاده نشده) */
export const nextSubjectColor = (subjects = []) => {
  const used = new Set(subjects.map((s) => normalizeHex(s.color)));
  return SUBJECT_COLOR_PRESETS.find((c) => !used.has(c)) || SUBJECT_COLOR_PRESETS[subjects.length % SUBJECT_COLOR_PRESETS.length];
};
